import Vue from "vue";
import VueI18n from "vue-i18n";
import HanshowUI from "@hs/hanshow-ui/locale";
import store from '@/store';
import _ from 'lodash';
const locales = window.languages;

// const elLocals = require.context('element-ui/lib/locale/lang', true, /\.js$/);
// const elementLocal = elLocals.keys().reduce((modules, modulePath) => {
//     const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
//     const value = elLocals(modulePath);
//     modules[moduleName] = value.default;
//     return modules;
// }, {});
const hsLocals = require.context("@hs/hanshow-ui/locale/lang", true, /\.js$/);
const hsLocal = hsLocals.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
    const value = hsLocals(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});

for (let key in locales) {
    if (key == 'en-US') {
        Object.assign(locales[key], hsLocal['en']);
    }
    Object.assign(locales[key], hsLocal[key]);
}

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: store.getters.language,
    fallbackLocale: 'en',
    messages: _.cloneDeep(locales),
});

//TODO 增加模式判断
// const originalTMethod = i18n.t.bind(i18n);
// i18n.t = function (key, options) {
//     const translatedValue = originalTMethod(key, options);
//     // 记录翻译 key 和结果（或其他你希望的操作）
//     return `@@${translatedValue}[${key}]`;
// };


HanshowUI.i18n((key, value) => i18n.t(key, value));
// Vue.prototype.$t = i18n.t.bind(i18n);
Vue.prototype.$setup = lang => {
    if (lang === undefined) {
        lang = store.getters.language;
    }

    store.dispatch('app/setLanguage', lang);
    Object.keys(locales).forEach(lang => {
        document.body.classList.remove(`lang-${lang}`);
    });
    document.body.classList.add(`lang-${lang}`);
    document.body.setAttribute('lang', lang);

    Vue.config.lang = lang;
    i18n.locale = lang;
};

const mergeSystemLanguage = (systemLocal = {}) => {
    Object.keys(systemLocal).forEach((lang) => {
        const langeuage = _.merge({}, locales[lang], systemLocal[lang]);
        i18n.setLocaleMessage(lang, langeuage);
    });
};

const changeMessageCust = (customerCode) => {
    Object.keys(locales).forEach((locale) => {
        i18n.setLocaleMessage(locale, _.merge({}, locales[locale], store.state.app.systemTranslate[locale]));
    });
    if (window.HS_CONST.custLanguageObj && window.HS_CONST.custLanguageObj[customerCode]) {
        Object.keys(locales).forEach(locale => {
            if (window.HS_CONST.custLanguageObj[customerCode][locale]) {
                const changeLang = _.merge({}, locales[locale], store.state.app.systemTranslate[locale], window[window.HS_CONST.custLanguageObj[customerCode][locale]]);
                i18n.setLocaleMessage(locale, changeLang);
                // i18n.mergeLocaleMessage(locale, window[window.HS_CONST.custLanguageObj[customerCode][locale]]);
            } else {
                i18n.setLocaleMessage(locale, locales[locale], store.state.app.systemTranslate[locale]);
            }
        });
    }

    Object.keys(store.state.app.custLanguage).forEach(lang => {
        const changeLang = _.merge({}, locales[lang], store.state.app.systemTranslate[lang], store.state.app.custLanguage[lang]);
        i18n.setLocaleMessage(lang, changeLang);
        // i18n.mergeLocaleMessage(lang, store.state.app.custLanguage[lang]);
    });

    // TODO增加是否开启了编辑模式的判断 if(){}
    // let storeTem
};

// const transformObject = (obj = {}) => {
//     const result = {};
//     for (const fullKey in obj) {
//         if (Object.prototype.hasOwnProperty.call(obj, fullKey)) {
//             // 分割键
//             const keys = fullKey.split('.');
//             const value = obj[fullKey];

//             let currentLevel = result;

//             for (let i = 0; i < keys.length; i++) {
//                 const key = keys[i];

//                 if (i === keys.length - 1) {
//                     // 在最后一级时赋值
//                     currentLevel[key] = value;
//                 } else {
//                     // 如果当前级不存在，则创建对象
//                     currentLevel[key] = currentLevel[key] || {};
//                     currentLevel = currentLevel[key];
//                 }
//             }
//         }
//     }
//     return result;
// };

export {
    changeMessageCust,
    mergeSystemLanguage,
};

export default i18n;
